<template>
  <edit-modal
      :is-show-dialog="isShowDialog"
      :action-label="actionLabel"
      :title="dialogTitle"
      @on-close="onClose"
      @on-action="onAction"
  >
    <v-overlay
        :absolute="true"
        :value="isModalLoading"
    >
      <v-progress-circular indeterminate size="24"></v-progress-circular>
    </v-overlay>
    <v-form
        ref="form"
        autocomplete="off"
        method="post"
        action=""
    >
      <v-container>
        <v-row
            v-model="valid"
            :lazy-validation="true"
        >
          <v-col cols="12"
                 style="position: relative"
          >
            <!--            <vue-google-autocomplete-->
            <!--              id="google-autocomplete"-->
            <!--              :google-api-key="googleApiKey"-->
            <!--              @placechanged="onPlaceChanged"-->
            <!--              style="width: calc(100% - 20px); border-bottom: 1px solid grey;"-->
            <!--              placeholder="Начните вводить адрес"-->
            <!--            />-->
            <span
                v-if="mapLink"
                style="position: absolute; top: 0; right: 0;"
            >
              <a :href="mapLink" target="_blank">
                <v-icon>mdi-google-maps</v-icon>
              </a>
            </span>
          </v-col>
          <!--START GOOGLE-->
          <v-col
              cols="12"
              md="4"
              class="py-0"
          >
            <v-text-field
                v-model="editableObject.country"
                :counter="200"
                :rules="[rules.max(200)]"
                :label="lang($store, 'sap/listings.global.filter.hints.country')"
                prepend-icon="mdi-map-marker"
                required
                disabled
                autocomplete="off"
                :error-messages="(errors && errors.country)?errors.country:null"
                @input="removeError('country')"
            ></v-text-field>
          </v-col>
          <v-col
              cols="12"
              md="4"
              class="py-0"
          >
            <v-select
                v-model="editableObject.region"
                :items="regionsItems"
                prepend-icon="mdi-home-city-outline"
                single-line
                :hint="lang($store, 'sap/listings.global.filter.hints.region')"
                :rules="[rules.required]"
                persistent-hint
                :error-messages="(errors && errors.region)?errors.region:null"
                @change="removeError('region')"
            ></v-select>
          </v-col>
          <v-col
              cols="12"
              md="4"
              class="py-0"
          >
            <v-text-field
                v-model="editableObject.city"
                :counter="200"
                :rules="[rules.required, rules.max(200)]"
                :label="lang($store, 'sap/listings.global.filter.hints.city')"
                prepend-icon="mdi-map-marker"
                required
                autocomplete="off"
                :error-messages="(errors && errors.city)?errors.city:null"
                @input="removeError('city')"
            ></v-text-field>
          </v-col>
          <v-col
              cols="12"
              md="4"
              class="py-0"
          >
            <v-text-field
                v-model="editableObject.neighborhood"
                :counter="200"
                :rules="[rules.max(200)]"
                :label="lang($store, 'sap/listings.global.filter.hints.neighborhood')"
                prepend-icon="mdi-map-marker"
                required
                autocomplete="off"
                :error-messages="(errors && errors.neighborhood)?errors.neighborhood:null"
                @input="removeError('neighborhood')"
            ></v-text-field>
          </v-col>
          <v-col
              cols="12"
              md="4"
              class="py-0"
          >
            <v-text-field
                v-model="editableObject.street"
                :counter="200"
                :rules="[rules.required, rules.max(200)]"
                prepend-icon="mdi-map-marker"
                required
                autocomplete="off"
                :error-messages="(errors && errors.street)?errors.street:null"
                @input="removeError('street')"
                @click:prepend="openMenu('showStreetNameSelector', $event)"
            >
              <template v-slot:label>
                 <span>
                  {{
                     lang(
                         $store,
                         `sap/listings.global.filter.street_type.${editableObject.street_type}`
                     )
                   }}
                </span>
              </template>
            </v-text-field>
          </v-col>
          <v-col
              cols="12"
              md="4"
              class="py-0"
          >
            <v-text-field
                v-model="editableObject.home_number"
                :counter="10"
                :rules="[rules.required, rules.max(10)]"
                :label="lang($store, 'sap/listings.global.filter.hints.home_number')"
                prepend-icon="mdi-city"
                required
                autocomplete="off"
                :error-messages="(errors && errors.home_number)?errors.home_number:null"
                @input="removeError('home_number')"
            ></v-text-field>
          </v-col>
          <!--<v-col
            cols="12"
            md="6"
            class="py-0"
          >
            <v-text-field
              v-model="editableObject.zip"
              :counter="10"
              :rules="[rules.max(10)]"
              :label="lang($store, 'sap/listings.global.filter.hints.zip')"
              prepend-icon="mdi-numeric"
              required
              autocomplete="off"
              :error-messages="(errors && errors.zip)?errors.zip:null"
              @input="removeError('zip')"
            ></v-text-field>
          </v-col>-->
          <!--END GOOGLE-->
          <v-col cols="12">
            <v-divider/>
          </v-col>
          <!--START MANUAL-->
          <v-col
              cols="12"
              sm="3"
              class="py-0"
          >
            <v-text-field
                v-model="editableObject.apartment"
                :counter="10"
                :rules="[rules.max(10)]"
                :label="lang($store, 'sap/listings.global.filter.hints.apartment')"
                prepend-icon="mdi-counter"
                required
                autocomplete="off"
                :error-messages="(errors && errors.apartment)?errors.apartment:null"
                @input="removeError('apartment')"
            ></v-text-field>
          </v-col>
          <v-col
              cols="12"
              sm="3"
              class="py-0"
          >
            <v-text-field
                v-model="editableObject.level"
                :counter="10"
                :rules="[rules.max(10)]"
                :label="lang($store, 'sap/listings.global.filter.hints.level')"
                prepend-icon="mdi-counter"
                required
                autocomplete="off"
                :error-messages="(errors && errors.level)?errors.level:null"
                @input="removeError('level')"
            ></v-text-field>
          </v-col>
          <v-col
              cols="12"
              sm="3"
              class="py-0"
          >
            <v-text-field
                v-model="editableObject.section"
                :counter="10"
                :rules="[rules.max(10)]"
                :label="lang($store, 'sap/listings.global.filter.hints.section')"
                prepend-icon="mdi-counter"
                required
                autocomplete="off"
                :error-messages="(errors && errors.section)?errors.section:null"
                @input="removeError('section')"
                @click:prepend="openMenu('showSectionNameSelector', $event)"
            >
              <template v-slot:label>
                 <span>
                  {{
                     lang(
                         $store,
                         `sap/listings.global.filter.section_type.${editableObject.section_type}`
                     )
                   }}
                </span>
              </template>
            </v-text-field>
          </v-col>
          <v-col
              cols="12"
              sm="3"
              class="py-0"
          >
            <v-text-field
                v-model="editableObject.staircase"
                :counter="10"
                :rules="[rules.max(10)]"
                :label="lang($store, 'sap/listings.global.filter.hints.staircase')"
                prepend-icon="mdi-counter"
                required
                autocomplete="off"
                :error-messages="(errors && errors.staircase)?errors.staircase:null"
                @input="removeError('staircase')"
            ></v-text-field>
          </v-col>
          <!--END MANUAL-->
          <v-col cols="12">
            <v-divider/>
          </v-col>
          <!--START META-->
          <v-col
              cols="12"
              md="3"
              class="py-0"
          >
            <v-select
                v-model="editableObject.premises_type"
                :items="premisesItems"
                prepend-icon="mdi-home-city-outline"
                single-line
                :hint="lang($store, 'sap/listings.global.filter.hints.premises_type')"
                persistent-hint
                :error-messages="(errors && errors.premises_type)?errors.premises_type:null"
                @change="removeError('premises_type')"
            ></v-select>
          </v-col>
          <v-col
              cols="12"
              md="3"
              class="py-0"
          >
            <v-text-field
                v-model="editableObject.area_meters"
                :rules="[rules.int]"
                :label="lang($store, 'sap/listings.global.filter.hints.area_meters')"
                prepend-icon="mdi-counter"
                required
                autocomplete="off"
                :error-messages="(errors && errors.area_meters)?errors.area_meters:null"
                @input="removeError('area_meters')"
            ></v-text-field>
          </v-col>
          <v-col
              cols="12"
              md="2"
              class="py-0"
          >
            <v-checkbox
                v-if="hooverModeEnable()"
                v-model="editableObject.is_hoover"
                :label="lang($store, 'sap/listings.global.filter.hints.hoover')"
                :true-value="1"
                :false-value="0"
            />
          </v-col>
          <v-col
            cols="12"
            md="2"
            class="py-0"
          >
            <v-checkbox
              v-model="editableObject.has_animals"
              :label="lang($store, 'sap/listings.global.filter.hints.animals')"
              :true-value="1"
              :false-value="0"
            />
          </v-col>
          <v-col
            cols="12"
            md="2"
            class="py-0"
          >
            <v-checkbox
              v-model="editableObject.is_commerce"
              :label="lang($store, 'sap/listings.global.filter.hints.commerce')"
            />
          </v-col>
          <v-col v-if="editableObject.premises_type==OFFICE"
            cols="12"
            md="4"
            class="py-0"
          >
            <v-text-field
              v-model="editableObject.time_limit"
              :counter="200"
              :rules="[rules.required, rules.max(200)]"
              prepend-icon="mdi-clock-outline"
              :label="lang($store, 'sap/listings.global.filter.hints.time_limit')"
              autocomplete="off"
              :error-messages="(errors && errors.time_limit)?errors.time_limit:null"
              @input="removeError('time_limit')"
            ></v-text-field>
          </v-col>
          <v-col
              cols="12"
              md="4"
              class="py-0"
          >
            <v-text-field
                v-model="editableObject.features"
                :counter="200"
                :rules="[rules.max(200)]"
                prepend-icon="mdi-login"
                :label="lang($store, 'sap/listings.global.filter.hints.features')"
                autocomplete="off"
                :error-messages="(errors && errors.features)?errors.features:null"
                @input="removeError('features')"
            ></v-text-field>
          </v-col>
          <v-col
              cols="12"
          >
            <v-textarea
                v-model="editableObject.additional_info"
                :counter="3000"
                :rules="[rules.max(3000)]"
                prepend-icon="mdi-account-badge-horizontal-outline"
                :label="lang($store, 'sap/listings.global.filter.hints.additional_info')"
                autocomplete="off"
                :error-messages="(errors && errors.additional_info)?errors.additional_info:null"
                @input="removeError('additional_info')"
            ></v-textarea>
          </v-col>
          <v-col
              cols="12"
              sm="8"
              v-if="item.uuid"
          >
            <v-textarea
                v-model="editableObject.clean_memo"
                :counter="9000"
                :rules="[rules.max(9000)]"
                prepend-icon="mdi-account-badge-horizontal"
                :label="lang($store, 'sap/listings.global.filter.hints.tech_card')"
                autocomplete="off"
                :error-messages="(errors && errors.clean_memo)?errors.clean_memo:null"
                @input="removeError('clean_memo')"
            ></v-textarea>
          </v-col>
          <v-col
              cols="12"
              sm="4"
              v-if="item.uuid"
          >
            <vue-dropzone
                ref="dropzone"
                id="attachmentsUploader"
                :options="dropOptions"
                @vdropzone-complete="afterComplete"
                @vdropzone-success="onFileUploaded"
                @vdropzone-error="onFileError"
                @vdropzone-processing="dropzoneChangeUrl"
            ></vue-dropzone>
          </v-col>
          <v-col
              cols="12"
              sm="12"
              class="py-md-0"
              v-if="item.uuid"
          >
            <v-row
                v-if="item.checklist_attachments && item.checklist_attachments.length > 0"
            >
              <v-col
                  cols="12"
                  md="3"
                  sm="4"
                  class="py-md-0"
                  v-for="attachment in item.checklist_attachments"
                  :key="attachment.id"
              >
                <div class="preview-attachment">
                  <a :href="attachment.link" target="_blank" class="preview-attachment__content"
                     style="display: block; position: relative; text-decoration: none"
                  >
                    <img
                        style="max-width: 100%"
                        v-if="isImage(attachment.link)"
                        :src="attachment.link"
                        :alt="attachment.link">
                    <div class="text" v-else>.{{
                        attachment.name.split('.')
                            .pop()
                      }}
                    </div>
                    <v-btn
                        icon
                        fab
                        dark
                        small
                        color="pink"
                        @click.prevent="deleteAttachment(attachment)"
                        style="position: absolute; top: 5px; right: 5px;"
                    >
                      <v-icon
                      >mdi-trash-can-outline
                      </v-icon>
                    </v-btn>
                  </a>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <!--END META-->
        </v-row>
      </v-container>
    </v-form>
    <v-menu
        v-model="showStreetNameSelector"
        :position-x="x"
        :position-y="y"
        style="max-width: 600px"
    >
      <v-list>
        <v-list-item
            v-for="streetType in streetTypes"
            :key="streetType"
            @click="selectStreetType(streetType)"
        >
          <v-list-item-title>{{
              lang($store, `sap/listings.global.filter.street_type.${streetType}`)
            }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-menu
        v-model="showSectionNameSelector"
        :position-x="x"
        :position-y="y"
        style="max-width: 600px"
    >
      <v-list>
        <v-list-item
            v-for="sectionType in sectionTypes"
            :key="sectionType"
            @click="selectSectionType(sectionType)"
        >
          <v-list-item-title>
            {{ lang($store, `sap/listings.global.filter.section_type.${sectionType}`) }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </edit-modal>
</template>

<script>
/* constants */
import * as promises from '@/constants/promises';
import { OFFICE } from '@/constants/promises';
import * as streetTypes from '@/constants/street_types';
import * as sectionTypes from '@/constants/section_types';
/* utils */
import {
  deepMerge, cloneObj, strReplaceAll, prepareValidationMessages,
} from '@/utils';
import AddressProxy from '@/proxies/Contact/AddressProxy';
/* mixins */
import editModalMixin from '@/mixins/editModalMixin';
import validationMixin from '@/mixins/validationMixin';
import regionsFilter from '@/mixins/filters/regionsFilter';
import settingsMixin from '@/mixins/settingsMixin';
/* components */
import EditModal from '@/components/listings/EditModal.vue';
// import VueGoogleAutocomplete from '@/components/VueGoogleAutocomplete.vue';
import VueDropzone from 'vue2-dropzone';

import { REGION_NAMES } from '~constants/region';
import i18n from '@/i18n';


export default {
  name: 'EditModalAddress',
  mixins: [
    editModalMixin,
    validationMixin,
    regionsFilter,
    settingsMixin,
  ],
  components: {
    EditModal,
    /**
     * Менеджеры не смотрят на адрес и допускают ошибки, заблочить временно
     * */
    // VueGoogleAutocomplete,
    VueDropzone,
  },
  props: {
    contact: {
      type: Object,
      default: () => {
      },
    },
    item: {
      type: Object,
      default: () => {
      },
    },
    errors: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      OFFICE,
      useNullableRegion: false,
      streetTypes,
      sectionTypes,
      x: 0,
      y: 0,
      googleApiKey: process.env.VUE_APP_GOOGLE_API_KEY,
      /* validation */
      valid: true,
      showStreetNameSelector: false,
      showSectionNameSelector: false,
      rules: {
        required: (v => !!v || this.lang(this.$store, 'sap/listings.global.validation.required')),
        min: (n => (v => ((v && v.length >= n) || !v) ||
                strReplaceAll(this.lang(this.$store, 'sap/listings.global.validation.min'), { count: n }))
        ),
        max: (n => (v => ((v && v.length <= n) || !v) ||
                strReplaceAll(this.lang(this.$store, 'sap/listings.global.validation.max'), { count: n }))
        ),
        phone: (v => /^\+\d{12}$/i.test(v) || this.lang(this.$store, 'sap/listings.global.validation.phone')),
      },
      /* Data */
      initialEditableObject: {
        uuid: '',
        premises_type: promises.ROOM1,
        country: REGION_NAMES.defaultCountryText || 'Украина',
        city: REGION_NAMES.defaultRegionText || 'Киев',
        street_type: streetTypes.STREET,
        section_type: sectionTypes.SECTION,
        region: null,
        is_hoover: 0,
        has_animals: 0,
        is_commmerce: false,
        area_meters: 0,
        time_limit: null,
      },
      editableObject: {},
      dropOptions: {
        url: '/',
        method: 'post',
        maxFilesize: 30, // MB
        maxFiles: 20,
        clickable: true,
        acceptedFiles: '.png,.jpg,.jpeg'/* ,.mov */,
        // chunking: true,
        // chunkSize: 500, // Bytes
        // thumbnailWidth: 150, // px
        // thumbnailHeight: 150,
        addRemoveLinks: true,
        headers: {
          'Cache-Control': null,
          'X-Requested-With': null,
          Authorization: `Bearer ${localStorage.getItem('id_token')}`,
          Accept: 'application/json',
        },
        dictDefaultMessage: i18n.t('uploads.dictDefaultMessage'),
        dictFallbackMessage: i18n.t('uploads.dictFallbackMessage'),
        dictFallbackText: i18n.t('uploads.dictFallbackText'),
        dictFileTooBig: i18n.t('uploads.dictFileTooBig'),
        dictInvalidFileType: i18n.t('uploads.dictInvalidFileType'),
        dictResponseError: i18n.t('uploads.dictResponseError'),
        dictCancelUpload: i18n.t('uploads.dictCancelUpload'),
        dictCancelUploadConfirmation: i18n.t('uploads.dictCancelUploadConfirmation'),
        dictRemoveFile: i18n.t('uploads.dictRemoveFile'),
        dictMaxFilesExceeded: i18n.t('uploads.dictMaxFilesExceeded'),
      },
    };
  },
  mounted() {
    this.initEditableObject();
  },
  computed: {
    mapLink() {
      if (
        this.editableObject.city &&
          this.editableObject.street &&
          this.editableObject.home_number
      ) {
        const text = `${this.editableObject.country}, ${this.editableObject.city}, ${this.editableObject.street} ${this.editableObject.home_number}`;
        return `https://www.google.com/maps/search/${text}`;
      }
      return null;
    },
    account() {
      return this.$store.getters['account/account'];
    },
    isCreation() {
      return !this.item || !(this.item.uuid);
    },
    dialogTitle() {
      return !this.isCreation ?
        (`${this.lang(this.$store, 'sap/listings.address.update_for')}: ${this.contact.name}`) :
        (`${this.lang(this.$store, 'sap/listings.address.create_for')}: ${this.contact.name}`);
    },
    premisesItems() {
      const items = [];
      Object.keys(promises)
        .forEach(key => {
          items.push({
            text: this.lang(this.$store, `sap/listings.global.filter.premises.${promises[key]}`),
            value: promises[key],
          });
        });
      return items;
    },
  },
  watch: {
    isShowDialog(newVal) {
      if (newVal) {
        this.initEditableObject();
        this.resetValidation();
      }
    },
    'editableObject.region': {
      handler(newVal, oldVal) {
        if (!this.editableObject.city ||
            this.editableObject.city === this.lang(
              this.$store,
              `sap/listings.global.filter.regions.${oldVal}`,
            )
        ) {
          this.editableObject.city = this.lang(
            this.$store,
            `sap/listings.global.filter.regions.${newVal}`,
          );
        }
      },
    },
    'editableObject': {
      handler: function (newVal, oldVal) {
        if (oldVal.uuid == newVal.uuid &&
          ((oldVal.premises_type != this.OFFICE && newVal.premises_type == this.OFFICE) ||
          (oldVal.premises_type == this.OFFICE && newVal.premises_type != this.OFFICE)) ) {

          this.editableObject.time_limit = null;
        }
      },
      deep: true
    },
  },
  methods: {
    dropzoneChangeUrl() {
      this.$refs.dropzone.setOption('url', `${process.env.VUE_APP_API_LOCATION}/addresses/${this.item.uuid}/attachments`);
    },
    fetchData() {
      new AddressProxy().find(this.item.uuid)
        .then(response => {
          this.item.checklist_attachments = response.data.data.address.checklist_attachments;
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
        });
    },
    deleteAttachment(attachment) {
      new AddressProxy().deleteAttachment(this.item.uuid, attachment.id)
        .then(response => {
          this.item.checklist_attachments = response.data.data.address.checklist_attachments;
        });
    },
    initEditableObject() {
      this.editableObject = deepMerge(cloneObj(this.initialEditableObject), this.item);
    },
    resetValidation() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    onAction() {
      if (this.$refs.form.validate()) {
        this.$emit('on-action', {
          item: this.contact,
          address: this.editableObject,
        });
      }
    },
    removeError(key) {
      if (this.errors && this.errors[key]) {
        this.errors[key] = null;
      }
    },
    /**
     * When the location found
     * @param {Object} addressData Data of the found location
     * @param {Object} placeResultData PlaceResult object
     * @param {String} id Input container ID
     */
    getAddressData(addressData, placeResultData, id) {
      // this.address = addressData;
      console.log(addressData);
      console.log(placeResultData);
      console.warn(id);
    },
    selectStreetType(streetType) {
      this.editableObject.street_type = streetType;
    },
    selectSectionType(sectionType) {
      this.editableObject.section_type = sectionType;
    },
    openMenu(handler, e) {
      e.preventDefault();
      this[handler] = true;
      this.x = e.clientX;
      this.y = e.clientY;
    },
    onPlaceChanged({ formatted }) {
      // console.warn(data);
      if (formatted.street_number) {
        this.editableObject.home_number = formatted.street_number;
      }
      if (formatted.route) {
        this.editableObject.street = formatted.route;
      }
      if (formatted.locality) {
        this.editableObject.city = formatted.locality;
      }
      if (formatted.latitude && formatted.longitude) {
        this.editableObject.lat = formatted.latitude;
        this.editableObject.lng = formatted.longitude;
      }
    },
    afterComplete(file) {
      this.$refs.dropzone.removeFile(file);
    },
    onFileError(file, response) {
      const errors = prepareValidationMessages(response.data);
      if (errors.file) {
        this.$store.dispatch('page/displaySnackbar', {
          text: errors.file,
          color: 'red darken-3',
          timeout: 6000,
        });
      }
    },
    onFileUploaded() {
      this.fetchData();
    },
    isImage(url) {
      return (url.match(/\.(jpeg|jpg|gif|png)$/) != null);
    },
  },
};
</script>

<style lang="sass" scoped>

</style>
